import { render } from "./GalleryFilterItem.vue?vue&type=template&id=b37ba68a&scoped=true"
import script from "./GalleryFilterItem.vue?vue&type=script&lang=js"
export * from "./GalleryFilterItem.vue?vue&type=script&lang=js"

import "./GalleryFilterItem.vue?vue&type=style&index=0&id=b37ba68a&scoped=true&lang=scss"

import exportComponent from "/home/projects/endangeredlabs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b37ba68a"]])

export default __exports__